export default __webpack_public_path__ + "static/media/Menu_Icon_Projects.a1b4ad96.svg";